var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { resetUploadState, useFileExplorerStore } from "./store";
import { concatenatePaths, isFileSystemDirectoryEntry, readDirectory, } from "./utils";
var FileTraversalStateManager = /** @class */ (function () {
    function FileTraversalStateManager() {
        var _this = this;
        this.files = [];
        this.directories = [];
        this.addFile = function (file) {
            _this.files.push(file);
        };
        this.addFolder = function (folder) {
            _this.directories.push(folder);
        };
    }
    return FileTraversalStateManager;
}());
export { FileTraversalStateManager };
export var createActions = function (props, refetch) {
    var api = props.api;
    var actions = {
        createFolder: function () { return __awaiter(void 0, void 0, void 0, function () {
            var store, name, path, err_1, error, errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        store = useFileExplorerStore.getState();
                        name = store.newFolderName;
                        if (!store.path || !name) {
                            useFileExplorerStore.setState({
                                newFolderName: null,
                                createFolderErrorMessage: null,
                            });
                            return [2 /*return*/];
                        }
                        path = concatenatePaths(store.path, name);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.createDirectory(path)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        error = err_1;
                        errorMessage = error === null || error === void 0 ? void 0 : error.message;
                        useFileExplorerStore.setState({
                            createFolderErrorMessage: errorMessage,
                        });
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, refetch()];
                    case 5:
                        _a.sent();
                        useFileExplorerStore.setState({
                            newFolderName: null,
                            createFolderErrorMessage: null,
                        });
                        return [2 /*return*/];
                }
            });
        }); },
        renameFile: function () { return __awaiter(void 0, void 0, void 0, function () {
            var store, _a, initialFileName, newFileName, path, originalPath, newPath, err_2, error, errorMessage;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        store = useFileExplorerStore.getState();
                        _a = store.renaming, initialFileName = _a.initialFileName, newFileName = _a.newFileName;
                        path = store.path;
                        if (!path || !initialFileName || !newFileName) {
                            // Interrupt the renaming process
                            useFileExplorerStore.setState({
                                renaming: {
                                    newFileName: null,
                                    initialFileName: null,
                                },
                            });
                            return [2 /*return*/];
                        }
                        if (initialFileName.trim() === newFileName.trim()) {
                            // Interrupt the renaming process
                            useFileExplorerStore.setState({
                                renaming: {
                                    newFileName: null,
                                    initialFileName: null,
                                },
                            });
                            return [2 /*return*/];
                        }
                        originalPath = concatenatePaths(path, initialFileName);
                        newPath = concatenatePaths(path, newFileName);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.renameFile(originalPath, newPath)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        error = err_2;
                        errorMessage = error === null || error === void 0 ? void 0 : error.message;
                        useFileExplorerStore.setState({
                            renameErrorMessage: errorMessage,
                        });
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, refetch()];
                    case 5:
                        _b.sent();
                        useFileExplorerStore.setState({
                            renaming: {
                                initialFileName: null,
                                newFileName: null,
                            },
                            selectedFiles: [],
                        });
                        return [2 /*return*/];
                }
            });
        }); },
        onCreateFolderClick: function () {
            useFileExplorerStore.setState({
                newFolderName: "",
                createFolderErrorMessage: null,
            });
        },
        stopCreatingFolder: function () {
            useFileExplorerStore.setState({
                newFolderName: null,
                createFolderErrorMessage: null,
            });
        },
        onRenameClick: function (selectedItems) {
            // The button will also be disabled if there the selected items count is not 1
            if (selectedItems.length !== 1) {
                return;
            }
            useFileExplorerStore.setState({
                renaming: {
                    initialFileName: selectedItems[0].displayName,
                    newFileName: selectedItems[0].displayName,
                },
                selectedFiles: [],
            });
        },
        stopRenaming: function () {
            useFileExplorerStore.setState({
                renaming: {
                    initialFileName: null,
                    newFileName: null,
                },
                renameErrorMessage: null,
            });
        },
        uploadFiles: function (files) { return __awaiter(void 0, void 0, void 0, function () {
            var store, currentPath, _loop_1, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        store = useFileExplorerStore.getState();
                        currentPath = store.path;
                        if (!currentPath) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 6, 7]);
                        useFileExplorerStore.setState({
                            uploading: {
                                files: files,
                                currentFileIndex: 0,
                                currentFileUploadPercentage: 0,
                            },
                        });
                        _loop_1 = function (i) {
                            var _b, file, path, filePath, folderPath;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _b = files[i], file = _b.file, path = _b.path;
                                        filePath = concatenatePaths(currentPath, path);
                                        folderPath = filePath.substring(0, filePath.lastIndexOf("/"));
                                        return [4 /*yield*/, api.storeFile(file, folderPath, function (bytesTransferred) {
                                                var fileSize = file.size;
                                                var progressPercentage = Math.floor((bytesTransferred / fileSize) * 100);
                                                useFileExplorerStore.setState({
                                                    uploading: __assign(__assign({}, useFileExplorerStore.getState().uploading), { currentFileUploadPercentage: progressPercentage, currentFileIndex: i }),
                                                });
                                            })];
                                    case 1:
                                        _c.sent();
                                        actions.triggerRefetch();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        i = 0;
                        _a.label = 2;
                    case 2:
                        if (!(i < files.length)) return [3 /*break*/, 5];
                        return [5 /*yield**/, _loop_1(i)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        resetUploadState();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        }); },
        onDrop: function (event) { return __awaiter(void 0, void 0, void 0, function () {
            var initialPath, items, fileTraversalStateManager, i, file, fileSystemEntry, _i, _a, directory, path;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        event === null || event === void 0 ? void 0 : event.preventDefault();
                        event.stopPropagation();
                        initialPath = useFileExplorerStore.getState().path;
                        items = (_c = (_b = event.dataTransfer) === null || _b === void 0 ? void 0 : _b.items) !== null && _c !== void 0 ? _c : [];
                        fileTraversalStateManager = new FileTraversalStateManager();
                        i = 0;
                        _d.label = 1;
                    case 1:
                        if (!(i < items.length)) return [3 /*break*/, 5];
                        file = items[i].getAsFile();
                        fileSystemEntry = items[i].webkitGetAsEntry();
                        if (!((fileSystemEntry === null || fileSystemEntry === void 0 ? void 0 : fileSystemEntry.isFile) && file)) return [3 /*break*/, 2];
                        fileTraversalStateManager.addFile({
                            file: file,
                            path: fileSystemEntry.fullPath,
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        if (!isFileSystemDirectoryEntry(fileSystemEntry)) return [3 /*break*/, 4];
                        fileTraversalStateManager.addFolder({
                            path: fileSystemEntry.fullPath,
                        });
                        return [4 /*yield*/, readDirectory(fileSystemEntry, fileTraversalStateManager)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 1];
                    case 5:
                        _i = 0, _a = fileTraversalStateManager.directories;
                        _d.label = 6;
                    case 6:
                        if (!(_i < _a.length)) return [3 /*break*/, 9];
                        directory = _a[_i];
                        path = concatenatePaths(initialPath, directory.path);
                        return [4 /*yield*/, api.createDirectory(path)];
                    case 7:
                        _d.sent();
                        _d.label = 8;
                    case 8:
                        _i++;
                        return [3 /*break*/, 6];
                    case 9:
                        actions.triggerRefetch();
                        return [4 /*yield*/, actions.uploadFiles(fileTraversalStateManager.files)];
                    case 10:
                        _d.sent();
                        actions.triggerRefetch();
                        return [2 /*return*/];
                }
            });
        }); },
        downloadFiles: function (files) { return __awaiter(void 0, void 0, void 0, function () {
            var store, initialPath, i, file, path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        store = useFileExplorerStore.getState();
                        initialPath = store.path;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < files.length)) return [3 /*break*/, 5];
                        file = files[i];
                        if (!(file.type === "folder")) return [3 /*break*/, 2];
                        return [3 /*break*/, 4];
                    case 2:
                        if (!(file.path && initialPath)) return [3 /*break*/, 4];
                        path = concatenatePaths(initialPath, file.path);
                        return [4 /*yield*/, api.retrieveFile(path)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 1];
                    case 5: return [2 /*return*/];
                }
            });
        }); },
        deleteFiles: function (files) { return __awaiter(void 0, void 0, void 0, function () {
            var store, initialPath, i, file, path;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        store = useFileExplorerStore.getState();
                        initialPath = store.path;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < files.length)) return [3 /*break*/, 4];
                        file = files[i];
                        if (!(file.path && initialPath)) return [3 /*break*/, 3];
                        path = concatenatePaths(initialPath, file.path);
                        return [4 /*yield*/, api.deleteFile(path)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        actions.triggerRefetch();
                        useFileExplorerStore.setState({ selectedFiles: [] });
                        return [2 /*return*/];
                }
            });
        }); },
        triggerRefetch: function () {
            // Trigger an update for the UI to refresh and continue without waiting
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            refetch();
        },
    };
    return actions;
};
